import { Component, Input } from '@angular/core'
import { SvgIconComponent } from 'angular-svg-icon'

import { NumberComponent, NumberTypes } from '../number/number.component'

@Component({
  selector: 'app-page-headline',
  imports: [SvgIconComponent, NumberComponent],
  templateUrl: './page-headline.component.html',
})
export class PageHeadlineComponent {
  @Input({ required: true }) public headline!: string
  @Input({ required: false }) public isLoading?: boolean = undefined
  @Input({ required: false }) public count?: number | string = undefined
  @Input({ required: false }) public type: NumberTypes = 'notice'
}
